export default "__VITE_ASSET__a053ce48__"